/**
 * Copyright (c) 2025 Adaptive Chaos Labs, LLC
 * All rights reserved.
 */

import React from 'react';
import type { TestedScope } from './tested-value.model';

/**
 * **The tested values in force where a slot renders** (`X55b`, `S3b`).
 *
 * A context rather than a prop, because the scope is **lexical** and so is React's tree: a case ladder
 * provides one per position, a nested decision provides its own on top, and a slot reads the nearest.
 * Threading it as a prop would put it on every form between the ladder and a value line — a dozen
 * components that have nothing to say about it.
 *
 * **Empty by default, and that is an answer rather than a gap**: outside any conditional there is no
 * case, so nothing is tested, and a mapping row, the library's own line and every other surface with
 * no ladder above it offer no *Tested value…* chip because the question does not arise there.
 */
export const TestedScopeContext = React.createContext<TestedScope>([]);

export const useTestedScope = (): TestedScope => React.useContext(TestedScopeContext);
